import { AcquiringChannelFlags } from 'src/context/salesforce-context';
import { checkAcquiringChannel } from 'src/helpers/devices';

export const isRented = (merchant) =>
  checkAcquiringChannel(
    AcquiringChannelFlags.rentOnlineFicaOnline,
    merchant?.opportunity?.deliveries,
  );
